'use client';

import Clarity from '@microsoft/clarity';
import { type FC, useEffect } from 'react';

const hasConsent = (): boolean => {
    const consentGranted = localStorage.getItem('consentGranted');

    if (!consentGranted) {
        return false;
    }

    try {
        return JSON.parse(atob(consentGranted)).statistics === 'granted';
    } catch {
        return false;
    }
};

const loadClarityScript = (): boolean => {
    if ('clarity' in window) {
        return false;
    }

    if (hasConsent()) {
        Clarity.init('r3zecm3jxt');

        return true;
    }

    return false;
};

export const ClarityScript: FC = () => {
    useEffect(() => {
        if (process.env['NODE_ENV'] === 'development') {
            return;
        }

        if (!loadClarityScript()) {
            window.addEventListener('grantCookieConsent', loadClarityScript);
        }

        return (): void => {
            window.removeEventListener('grantCookieConsent', loadClarityScript);
        };
    }, []);

    return null;
};
